import { handleWidgetUpdate } from '@juvare/common-form-ui/WidgetForm/Utils';
import { WidgetComponent } from '@juvare/widget-ui/WidgetComponent';
import { Box } from '@mui/material';
import React from 'react';
import { type } from './types';
const WidgetFilterForm = (props) => {
    return (React.createElement(Box, { "data-widget-type": type }, props.childProps &&
        props.childProps.length > 0 &&
        props.childProps.map((childProp, index, array) => (React.createElement(Box, { key: childProp.id, "data-widget": childProp.dataPath, sx: { borderBottom: index < array.length - 1 ? (theme) => `1px solid ${theme.palette.divider}` : undefined } },
            React.createElement(WidgetComponent, Object.assign({}, childProp)))))));
};
/**
 * Definition for the `filter.form` widget.
 */
export const widgetFilterForm = {
    type,
    update: (props) => handleWidgetUpdate(props),
    childConfigs: (config) => config.children,
    component: WidgetFilterForm,
};
